export const ASIDE_WIDTH = 240;
export const TAB_HEIGHT = 50;
export const ASIDE_ITEM_HEIGHT = 56;
export const HEADER_PORTAL_ID = 'headerPortal';
export const HEADER_TOOLBAR_PORTAL_ID = 'headerPortalToolbar';
